var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermission24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_Permission24x24",
    d: "M12.148,2.7A14.648,14.648,0,0,1,5.7,4.59a.958.958,0,0,0-.7.9v6.169c0,5.075,3.423,6.368,7.047,8.757a.762.762,0,0,0,.906,0C16.577,18.023,20,16.73,20,11.655V5.485a.848.848,0,0,0-.7-.8A18.469,18.469,0,0,1,12.852,2.8.434.434,0,0,0,12.148,2.7ZM11.141,12.65l3.725-3.682a.678.678,0,0,1,1.007,0,.66.66,0,0,1,0,1h0l-4.128,4.08a.769.769,0,0,1-1.007.1h0L9.128,12.55a.75.75,0,0,1,0-1,.758.758,0,0,1,.906,0Z",
    transform: "translate(-5 -2.561)",
    fill: "#999",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermission24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_Permission24x24.ae53f1804e609eb98132a5212997ab6a.svg";